import { alpha, Theme } from '@mui/material';

export default {
    field: {
        borderColor: (theme: Theme) => alpha(theme.palette.primary.main, 0.64),
        input: {
            pl: 1,
            r: 1.5,
        },
    },
    fieldWithTestButton: { borderRight: 0, borderTopRightRadius: 0, borderBottomRightRadius: 0 },
    btn: {
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
    },
    row: {
        display: 'flex',
        marginBottom: '20px',

        '> .MuiTypography-root:first-of-type': {
            width: '190px',
            textAlign: 'right',
            paddingRight: '10px',
        },
    },
    textField: {
        marginBottom: '16px',

        '&:first-of-type': {
            marginTop: '8px',
        },

        '&:last-of-type': {
            marginBottom: '8px',
        },

        '.MuiInputBase-root .Mui-disabled': {
            color: (theme: Theme) => `${theme.palette.text.primary} !important`,
        },

        '.MuiFormLabel-root': {
            display: 'flex',
        },
    },
    label: {
        marginBottom: '4px',
        display: 'flex',
    },
    dialogContainer: { justifyContent: 'normal', py: 2, px: 3, flexWrap: 'wrap' },
    divider: {
        width: '1px',
        height: '16px',
        backgroundColor: (theme: Theme) => alpha(theme.palette.text.primary, 0.08),
        mx: 0.5,
        alignSelf: 'center',
    },
    fullUrl: {
        flexBasis: 'calc(100% - 190px)',
        wordBreak: 'break-all',
    },
    externalUrlRow: {
        marginTop: '20px',
        marginBottom: '10px',
    },
    externalUrlForm: {
        '.MuiInput-root': {
            width: '100%',
        },

        'a:hover': {
            textDecoration: 'none',
        },
    },
    testLink: {
        'a:hover': {
            textDecoration: 'none',
        },
    },
    generatedUrl: {
        width: '80%',
    },
    generatedUrlText: {
        wordBreak: 'break-all',
    },
};
